commusoftCommon.directive('attachedFilesUploadArea', function () {
    return {
        restrict: 'EAC',
        controller: fileUploadCtrl
    }
});
